import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const painPoints = ['Perdés los fines de semana buscando planos en internet y el lunes empezás de cero sin nada claro', 'Proyectos complejos (camas Murphy, mesas con pistón, bancos de trabajo) sin planos detallados ni lista de corte exacta', 'El 60% de los presupuestos que mandás no cierran porque no sabés cómo presentar el precio', 'Tableros de melamina tirados a la basura por errores de cálculo que te queman el margen', 'Clientes que te preguntan "¿me garantizás que no se cae?" y vos no tenés un protocolo de anclaje documentado', 'Mecanismos plegables que fallan a los 3 meses porque usaste el herraje equivocado', 'No podés justificar un precio premium porque no tenés un sistema profesional visible', 'Bisagras desalineadas, rieles trabados, ruedas que se van de costado: errores que te generan reclamos', 'No sabés cuánto cobrar cuando incorporás un ayudante sin perder margen'];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-255">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-257">
          <h2 className="text-3xl md:text-4xl font-bold text-wood-dark mb-4" data-id="element-258">
            Si sos carpintero emprendedor en Argentina, esto te va a sonar
            familiar:
          </h2>
          <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-259"></div>
        </motion.div>

        <div className="space-y-4 mb-16" data-id="element-260">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start p-4 rounded-lg hover:bg-cream-dark/50 transition-colors" data-id="element-261">
              <XCircle className="w-6 h-6 text-red-500/80 mt-0.5 mr-4 flex-shrink-0" data-id="element-262" />
              <p className="text-lg text-charcoal/80" data-id="element-263">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-wood-dark text-cream p-8 md:p-12 rounded-2xl text-center shadow-warm wood-texture" data-id="element-264">
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-amber-light mb-0" data-id="element-265">
            ¿Cuántos tableros más vas a tirar a la basura haciendo lo mismo?
          </h3>
        </motion.div>
      </div>
    </section>;
}